// extracted by mini-css-extract-plugin
export default {"dashboard-container":"ffa4c1"};